import React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

interface IPropsAddStageButton {
    handleAddStage: any;
    listStages: Compleo.IObject[];
    t: any;
}

const AddStageButton = (props: IPropsAddStageButton) => {
    const { handleAddStage, listStages, t } = props;

    return (
        <Button
            color="secondary"
            size="small"
            style={{ margin: "16px" }}
            startIcon={<AddIcon />}
            onClick={() => handleAddStage(listStages.length)}
        >
            {t("button_addStage")}
        </Button>
    );
};

export default AddStageButton;
